import type { ConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import type { AxiosResponse } from 'axios';
import { getNodeApiAxiosInstance } from '#client';
import type { MedicalGroupListDataObject } from '#models/services';
import type { PaginationExtendedData } from '#types';
import { routes } from '../routes';

export type MedicalGroupsRequestParams = paths['/medical-groups']['get']['parameters']['query'];
type MedicalGroupsDataObjectWithPagination = PaginationExtendedData<MedicalGroupListDataObject>;

export const getMedicalGroups = async ({ config }: ConfigRequest<MedicalGroupsRequestParams>) =>
  getNodeApiAxiosInstance().get<
    MedicalGroupsDataObjectWithPagination,
    AxiosResponse<MedicalGroupsDataObjectWithPagination>
  >(routes.medicalGroups.find, config);
